<!--  -->
<template>
  <div> 
    <template v-if="eleTokenWrd001">
      <news-show :plates="plates" v-if="plates.length > 0" />
      <center-model :plates="plates" v-if="plates.length > 0"/>
      <exam-center/>
      <course-center/>
      <live-center/>
      <!-- <ConcantUs></ConcantUs> -->
      <LiveBlogroll></LiveBlogroll>
    </template>  
    <template v-else>
       <div class="toptitle">
        <div class="box"> 
          <div class="title">一体化岗位领域人才能力培养测评服务平台</div>
          <ul class="tip">
            <li style="border-right:1px solid #456CC8;">专业化</li>
            <li style="border-right:1px solid #456CC8;">公信力</li>
            <li>创新性</li>
          </ul>
        </div>
      </div>
      <Board :plates="plates" v-if="plates.length > 0" />
      <Subject :plates="plates" v-if="plates.length > 0" />
      <Talentinfo :plates="plates" v-if="plates.length > 0" />
      <EvaluationService :plates="plates" v-if="plates.length > 0" />
      <div class="live">
        <LiveBlogroll></LiveBlogroll>
      </div>
    </template>
  </div>
</template>

<script>
//
import Board from "@/components/HomeComs/Board.vue";
import Subject from "@/components/HomeComs/Subject.vue";
import Talentinfo from "@/components/HomeComs/Talentinfo.vue";
import EvaluationService from "@/components/HomeComs/EvaluationService.vue";
import CenterModel from "@/components/HomeComs/CenterModel.vue";
import ExamCenter from "@/components/HomeComs/ExamCenter.vue";
import NewsShow from "@/components/HomeComs/NewsShow.vue";
import CourseCenter from "../components/HomeComs/CourseCenter.vue";
import LiveCenter from '../components/HomeComs/LiveCenter.vue';
// import ConcantUs from '../components/HomeComs/ConcantUs.vue';
import LiveBlogroll from '../components/HomeComs/LiveBlogroll.vue';
const rate= window.innerWidth/1920;
export default {
  
  metaInfo: {
    meta: [
      { name:'viewport', content:
      `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`}
    ]
  },
  data() {
    return {
      eleTokenWrd001: false
    };
  },
  props: {
    plates: Array,
  },
  components: { NewsShow, CenterModel, ExamCenter, CourseCenter, LiveCenter , LiveBlogroll , Board, Subject, Talentinfo, EvaluationService },

  mounted() {
    this.eleTokenWrd001 = localStorage.eleTokenWrd001;
  },

  methods: {},
};
</script>
<style  scoped>
.live >>>.blogroll{
  margin-top: 30px;
}
.toptitle{
  width: 100%;
height: 530px;
background-image: url(/static/img/cepingshouyebanne.png);
background-repeat: no-repeat;
background-size: cover;
background-position: center;
overflow: hidden;
}
.box{
  width: 1200px;
  height: 200px;
  margin: 129px auto 0;
}
.toptitle .title{
     color: #4462cf;
    font-family: PingFang SC;
    font-size: 41px;
    font-weight: 700;
    height: 80px;
    line-height: 80px;
    position: relative;
    text-align: center;
    width: 884px;
}
.toptitle .title::before{
  position: absolute;
  content: '';
  top:0;
  left: 0;
  width: 28px;
  height: 28px;
background-image: url(/static/img/zuoshang.png);
background-repeat: no-repeat;
background-size: 28px 28px;
background-position: left top;
}
.toptitle .title::after{
  position: absolute;
  content: '';
  bottom: 0;
  right: 0;
  width: 28px;
  height: 28px;
  background-image: url(/static/img/upxian.png);
background-repeat: no-repeat;
background-size: 28px 28px;
background-position: right bottom;
}
.tip{
  margin-top: 35px;
  width: 545px;
  height: 69px;
  border-top:1px solid #456CC8 ;
  border-bottom:1px solid #456CC8;
  display: flex;
  justify-content: start;
  align-items: center;
}
.tip li{
  float: left;
 padding-left: 52px ;
 padding-right:56px ;
height: 37px;
font-size: 24px;
font-family: PingFang SC;
font-weight: 500;
color: #4462CF;
line-height: 37px;
}
</style>
